import { render, staticRenderFns } from "./TitleSimple.vue?vue&type=template&id=ba624498&"
import script from "./TitleSimple.vue?vue&type=script&lang=js&"
export * from "./TitleSimple.vue?vue&type=script&lang=js&"
import style0 from "./TitleSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports